import { useInternationalization } from '@progress/kendo-react-intl'
import React from 'react'

import { type BrandAccountUser } from '../hooks/useMainQuery'

export type LoggedInAtCellProps = {
  dataItem: BrandAccountUser
}

export const LoggedInAtCell = ({ dataItem }: LoggedInAtCellProps) => {
  const intl = useInternationalization()

  const formattedDate = React.useMemo(() => {
    if (!dataItem.loggedInAt) {
      return ''
    }

    return intl.formatDate(new Date(dataItem.loggedInAt), 'yyyy/MM/dd HH:mm')
  }, [dataItem.loggedInAt, intl])

  return <td>{formattedDate}</td>
}
